export const FORM = 'gift-cards/form';
export const ADD_CARD_FORM = 'gift-cards/add-card-form';

// Actions
export const FETCH_GIFT_CARDS = 'gift-cards/FETCH_GIFT_CARDS';
export const FETCH_GIFT_CARDS_SUCCESS = 'gift-cards/FETCH_GIFT_CARDS_SUCCESS';
export const FETCH_GIFT_CARD_SUMMARY = 'gift-cards/FETCH_GIFT_CARD_SUMMARY';
export const RESET_SOLD_GIFT_CARDS = 'gift-cards/RESET_SOLD_GIFT_CARDS';
export const SET_SOLD_GIFT_CARDS = 'gift-cards/SET_SOLD_GIFT_CARDS';
export const DELETE_GIFT_CARD = 'DELETE_GIFT_CARD';
export const ADD_GIFT_CARD = 'ADD_GIFT_CARD';
export const TOP_UP_CARD = 'TOP_UP_CARD';
